// Season-Bootstrap: Die Weltschicht liest ACTIVE_SEASON beim Modulimport.
// Deshalb muss der Browser die Server-ID kennen, *bevor* main.js und damit
// track/schedule/terrain importiert werden. Ein nachträglicher Wechsel würde
// Client und Server auf unterschiedliche Schienen setzen.

function configUrl() {
  const { protocol, hostname, port, host } = window.location;
  // Vite dev/preview kann für Tests auf beliebigen lokalen Ports laufen;
  // Production hat denselben Host/Proxy wie /config.
  const localVite = (hostname === 'localhost' || hostname === '127.0.0.1')
    && port !== '' && port !== '8787';
  if (localVite) return `${protocol}//${hostname}:8787/config`;
  return `${protocol}//${host}/config`;
}

async function boot() {
  let config = null;
  try {
    const res = await fetch(configUrl(), { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    config = await res.json();
  } catch (err) {
    // Offline-/Asset-Test bleibt auf der gebauten Default-Season S1. Eine
    // sichtbare Statuszeile erklärt den Fallback, statt still zu divergieren.
    console.warn('[season] /config nicht erreichbar, S1-Fallback:', err.message);
    config = { season: { id: 'S1' } };
  }

  const id = config?.season?.id ?? 'S1';
  globalThis.__TRAIN_SEASON_ID__ = id;
  globalThis.__TRAIN_SEASON_CONFIG__ = config.season ?? { id };
  await import('./main.js');
}

boot().catch((err) => {
  console.error('[spiel] Bootstrap fehlgeschlagen:', err);
  const status = document.getElementById('loading-status');
  if (status) status.textContent = `Start fehlgeschlagen: ${err.message}`;
});
